module.exports = __webpack_public_path__ + "img/header-phone.a6f2a15b.jpg";